import { compact } from "lodash";
import { useFormContext } from "react-hook-form";

import { TableSelectAllCheckbox } from "@/components/Layout/Table/TableSelectAllCheckbox/TableSelectAllCheckbox";
import { BillListBillIdForm } from "@/components/Portal/Documents/BillList/BillList";

/**
 * Adapts the bill list's form shape to TableSelectAllCheckbox, which works in
 * plain id arrays. This form predates that and stores the selection as an
 * object keyed by bill id (`{ [id]: id | false }`), so the ids are mapped to
 * strings on the way in and written back key by key on the way out.
 */
export const BillSelectAllCheckbox = ({
  currentPageBillIds,
}: {
  currentPageBillIds: number[];
}) => {
  const { watch, setValue } = useFormContext<BillListBillIdForm>();

  const selectedIds = compact(Object.values(watch("billIds"))).map(String);

  return (
    <TableSelectAllCheckbox
      dataTestid="bill-list-header-checkbox"
      currentPageIds={currentPageBillIds.map(String)}
      selectedIds={selectedIds}
      onChange={(nextSelectedIds) =>
        currentPageBillIds.forEach((billId) => {
          // The stored value stays the numeric id the rest of this form
          // expects (it reads the values back through `Number(...)`); only the
          // shared component's id contract is string-based.
          const isSelected = nextSelectedIds.includes(String(billId));

          // @ts-ignore - This works because billIds is an object, which we can index like this
          setValue(`billIds.${billId}`, isSelected ? billId : false);
        })
      }
    />
  );
};
